import React, { useCallback, useState } from "react";

import { ChildrenArgs as WorkbenchArgs } from "@common/components/Workbench/types";
import { Reading } from "../Reading";
import { State } from "../Reading/types";
import { mapStateToRawZones, RawZones, useInitialState } from "./useInitialState";
import { ApiJob } from "../../../common/api/v1.1/types/jobs";

type WorkbenchActions = WorkbenchArgs["actions"];

type Props = Readonly<{
  pageMeta: any;
  pageUris: Array<string>;
  onReset: () => Promise<void>;
  saveContent: (blocks: RawZones) => Promise<void>;
  showMessage: WorkbenchActions["showMessage"];
  submit: () => Promise<void>;
  review: boolean;
  zones: any;
  job: ApiJob;
}>;

export const WorkbenchInit = ({
  pageMeta,
  pageUris,
  onReset,
  saveContent,
  showMessage,
  submit,
  review,
  zones,
  job
}: Props) => {
  const [images, initialBlocks] = useInitialState(pageMeta, pageUris, zones, job);
  const [working, setWorking] = useState<boolean>(false);
  const onSave = useCallback(
    async (state: State) => {
      setWorking(true);
      try {
        const toSave = mapStateToRawZones(state);
        await saveContent(toSave);
      } catch (err) {
        console.error(err);
        showMessage(<span>{err.message}</span>, "Unexpected Error", undefined, "danger");
      }
      setWorking(false);
    },
    [saveContent, showMessage, setWorking],
  );
  const onSubmit = useCallback(
    async (state: State) => {
      setWorking(true);
      try {
        const toSave = mapStateToRawZones(state);
        await saveContent(toSave);
        await submit();
      } catch (err) {
        console.error(err);
        showMessage(<span>{err.message}</span>, "Unexpected Error", undefined, "danger");
      }
      setWorking(false);
    },
    [saveContent, showMessage, setWorking],
  );
  return (
    <Reading
      images={images}
      initialBlocks={initialBlocks}
      onReset={onReset}
      onSave={onSave}
      onSubmit={onSubmit}
      readonly={review}
      working={working}
    />
  );
};
